import { apiClient } from '@/core/api/client';
import { CareConciergeFormData, CareConciergeRequestResponse } from '../components/CareConciergContactForm/types';

export async function submitCareConciergeRequest(
  data: CareConciergeFormData
): Promise<CareConciergeRequestResponse> {
  return postCareConciergeRequest('/contact-requests', data);
}

/**
 * Guest (unauthenticated) submission. Hits the public endpoint authorized by
 * the guest-session token (auto-attached by the apiClient interceptor); the
 * request is stored ownerless with the contact details entered on the form.
 */
export async function submitGuestCareConciergeRequest(
  data: CareConciergeFormData
): Promise<CareConciergeRequestResponse> {
  return postCareConciergeRequest('/contact-requests/guest', data);
}

async function postCareConciergeRequest(
  url: string,
  data: CareConciergeFormData
): Promise<CareConciergeRequestResponse> {
  try {
    const response = await apiClient.post<CareConciergeRequestResponse>(url, data);
    return response.data;
  } catch (error) {
    console.error('Error submitting care concierge request:', error);
    const err = error as { message?: string; statusCode?: number };

    // Check statusCode first: apiClient always supplies a (often generic)
    // `message`, so message-first would make these friendly cases unreachable.
    if (err.statusCode === 400) {
      throw new Error('Please check your form and ensure all required fields are filled out correctly');
    }

    // 401 here means an expired session (guest-session token or auth) on either
    // the guest or authenticated path — not necessarily "not logged in".
    if (err.statusCode === 401) {
      throw new Error('Your session has expired. Please refresh the page and try again.');
    }

    if (err.message) {
      throw new Error(err.message);
    }

    throw new Error('Failed to submit request. Please try again later.');
  }
}
